export class BrokerageResponse {
  BrokerageID: number;
  Environment: NonNullable<"LIVE" | "TEST" | "DEV" | "LOCAL" | "">;
  ConveyanceID: number;
  MachineName: string;
  Active: boolean;
}
